export const columns = [
    { field: "_ctpt_nationalityid_value", headerName: "Nationality", width: 180 },
  
]